import type { CSSProperties } from "react";

type Props = {
  /** Stroke width in px; the host keeps a transparent border of half this. */
  width?: 2 | 4 | 6;
  /** Corner radius of the host's border box. */
  radius: number;
};

const arrays: Record<NonNullable<Props["width"]>, string> = {
  2: "var(--dash-thin)",
  4: "var(--dash-mid)",
  6: "var(--dash-thick)",
};

/**
 * Round-capped dashed edge (CSS `dashed` cannot cap). An SVG rect whose
 * stroke is centred on the host's border-box edge, as Figma centres strokes.
 * The host is `position: relative`, sets `--dash-color`, and carries a
 * transparent border of half the stroke so layout matches the mock.
 */
export function DashedEdge({ width = 2, radius }: Props) {
  const style = {
    ["--dash-w" as string]: `${width}px`,
    ["--dash-array" as string]: arrays[width],
  } as CSSProperties;
  return (
    <svg className="dashed-edge" style={style} aria-hidden>
      <rect width="100%" height="100%" rx={radius} />
    </svg>
  );
}
